var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useMemo } from "react";
import { affiliateApi } from "./affiliateApi";
/**
 * @description
 *  Provides a hook to register affiliate landing page so that the B/E integration with Awin
 *  can be supported.  The methods provided by the hook, will register the AWC checksum from the
 *  landing page via an affiliate promo endpoint (which will store it as a server side cookie).
 *  The completePurchase method will be used to register the completed booking with Awin using the
 *  cookie dropped on landing page.  This will be checked against the current AffiliatePromo being
 *  applied to BLAPI to ensure that the Awin affiliate was the latest applied promotion.
 *
 * @example normal usage
 *  const { registerLink } = useAffiliate({client: 'l-and-d'});
 *  ....
 *  recordLanding(new URLSearchParams(window.location.search));
 *
 * @example (override the affiliate base urls for local development)
 *  const { registerLink } = useAffiliate({
 *    affiliateUrl: 'http://localhost:3002',
 *    client: 'l-and-d'
 *  });
 *
 * @param config
 */
export const useAffiliate = (config) => {
    const api = useMemo(() => affiliateApi({
        affiliateUrl: config === null || config === void 0 ? void 0 : config.affiliateUrl,
        client: config.client,
    }), [config.affiliateUrl, config.client]);
    const registerLink = useCallback((params) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const awc = params === null || params === void 0 ? void 0 : params.get("awc");
            if (awc)
                yield api.create(awc);
        }
        catch (e) {
            // Ignore failures
        }
    }), [api]);
    const completePurchase = useCallback((reference, amount, commissionGroup) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (reference && amount)
                yield api.complete(reference, amount, commissionGroup || "");
        }
        catch (e) {
            // Ignore failures
        }
    }), [api]);
    return { registerLink, completePurchase };
};
